import { ErasureTable } from "../ErasureTable";
import type { ErasureReport } from "@/types/erasure";

const SAMPLE_REPORT: ErasureReport = {
  reportId: "ECR-12545",
  service: "Echorai Shield",
  createdAt: "2026-03-10",
  requests: [
    {
      id: "1",
      site: "MrKoll",
      status: "confirmed",
      requestedAt: "10 mar, 09:14",
      verificationUrl: "#",
    },
    {
      id: "2",
      site: "Ratsit",
      status: "pending",
      requestedAt: "10 mar, 09:16",
    },
    {
      id: "3",
      site: "Hitta.se",
      status: "confirmed",
      requestedAt: "10 mar, 09:18",
      verificationUrl: "#",
    },
    {
      id: "4",
      site: "Eniro",
      status: "confirmed",
      requestedAt: "10 mar, 09:20",
      verificationUrl: "#",
    },
    {
      id: "5",
      site: "Merinfo",
      status: "confirmed",
      requestedAt: "10 mar, 09:21",
      verificationUrl: "#",
    },
  ],
};

export function Verifications() {
  return (
    <div className="space-y-12">
      <p className="text-3xl font-bold text-center tracking-tight">
        Ditt verifierade raderingsbevis
      </p>
      <div className="mx-auto max-w-5xl lg:grid lg:grid-cols-2 lg:gap-12 lg:items-center">
        <div className="items-center text-center lg:text-start space-y-3">
          <p className="text-muted-foreground">
            Efter varje borttagning får du ett verifierat raderingsbevis.
          </p>
          <p className="text-muted-foreground">
            Det visar exakt status per källa, vad som tagits bort och när det
            skedde.
          </p>
          <p className="text-muted-foreground">
            Allt är spårbart och kan verifieras i efterhand.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 py-10 text-left">
            <div>
              <p className="font-bold">Verifierat raderingsbevis</p>
              <p className="font-light text-muted-foreground">
                Varje borttagning dokumenteras med unik rapport, tidsstämpel och
                verifierbar status.
              </p>
            </div>
            <div>
              <p className="font-bold">Rättsligt bindande borttagning</p>
              <p className="font-light text-muted-foreground">
                Alla borttagningar genomförs med din explicita auktorisering och
                kan verifieras i efterhand.
              </p>
            </div>
          </div>
        </div>
        <ErasureTable report={SAMPLE_REPORT} sample />
      </div>
    </div>
  );
}
